import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import axios from 'axios';
import { useState } from 'react';
import { Link, UNSAFE_ErrorResponseImpl, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { registerUser } from '../slice/authSlice';
import Swal from 'sweetalert2';

function RegisterPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const registerHandle = (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);
        const credentials = {
            "name": name,
            "email": email,
            "password": password
        }
        
        dispatch(registerUser(credentials)).unwrap().then((response) => {
            if(response.success){
                localStorage.setItem('authToken', response.token);
                navigate('/');
                Swal.fire("Success", response.message, 'success');
            }else{
                setError(response.message)
            }
            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);
            console.error(err);
        })
      };

    return (
        <div className='row justify-content-center align-items-center mt-5'>
            <div className='col-md-3'>
                <div className='card text-white' style={{ backgroundColor: '#28333f' }}>
                    <div className='card-body d-flex flex-column'>
                        <div className='d-flex justify-content-center mt-3 mb-2'>
                            <i className="bi bi-person-fill-add mx-2 bg-white rounded-circle px-2" style={{ fontSize: "30px", color: "#16a085" }}></i>
                        </div>
                        <div className='d-flex justify-content-center mb-3 mx-3'>
                            <h2 className='title fw-semibold'>REGISTER</h2>
                        </div>
                        <form onSubmit={registerHandle}>
                            <div className='row mx-3'>
                                <div className='col-md-12'>
                                    <div className='form-group mt-3'>
                                        <label>Name</label>
                                        <input type='text' onChange={(e) => setName(e.target.value)} value={name} className='form-control bg-transparent text-white' placeholder="Username" style={{ height: "55px", border: error && error.name ? "red 2px solid" : "#15191e 2px solid", borderRadius: "15px" }}></input>
                                        {error && error.name && error.name.map((errName, index) => (
                                            <div className="text-danger" key={index}>{errName}</div>
                                        ))}
                                    </div>
                                    <div className='form-group mt-3'>
                                        <label>Email</label>
                                        <input type='email' onChange={(e) => setEmail(e.target.value)} value={email} className='form-control bg-transparent text-white' placeholder="Email" style={{ height: "55px", border: error && error.email ? "red 2px solid" : "#15191e 2px solid", borderRadius: "15px" }}></input>
                                        {error && error.email && error.email.map((errEmail, index) => (
                                            <div className="text-danger" key={index}>{errEmail}</div>
                                        ))}
                                    </div>
                                    <div className='form-group mt-3'>
                                        <label>Password</label>
                                        <input type='password' onChange={(e) => setPassword(e.target.value)} value={password} className='form-control bg-transparent text-white' placeholder="Password" style={{ height: "55px", border: error && error.password ? "red 2px solid" : "#15191e 2px solid", borderRadius: "15px" }}></input>
                                            {error && error.password && error.password.map((errPassword, index) => (
                                                <div className="text-danger" key={index}>{errPassword}</div>
                                            ))}
                                    </div>
                                    <div className='d-flex justify-content-start'>
                                        <Link to={'/login'} className='fs-6' style={{ color: "#16a085" }}>Back to login</Link>
                                    </div>
                                    <div className='d-flex justify-content-start w-100'>
                                        <button type='submit' className='btn btn-light mt-3 w-100 fw-semibold fs-5' style={{ height: "50px" }} disabled={isLoading ? 'true' : false}>{isLoading ? 'Loading...' : 'REGISTRASI'}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RegisterPage;